import { AbstractControl, ValidationErrors } from '@angular/forms';
import { ApiResponse, ApiSuccessResponse } from '@app/core/types';
import { Observable, UnaryFunction, filter, pipe } from 'rxjs';

export function filterSuccess<T>(): UnaryFunction<
	Observable<ApiResponse<T>>,
	Observable<ApiSuccessResponse<T>>
> {
	return pipe(
		filter((response: ApiResponse<T>) => response.status === 'success')
	);
}

export function requiredStringValidator(
	control: AbstractControl
): ValidationErrors | null {
	const value =
		typeof control.value === 'string' ? control.value?.trim() : control.value;
	return value === '' ? { required: true } : null;
}

/**
 * Rol ABA legible para la UI: `BCBA_ROLE` → `BCBA`.
 *
 * El sufijo `_ROLE` es del enum del backend y no significa nada para un
 * terapeuta. Esta conversión estaba escrita a mano y por duplicado en
 * `chats-list` y `last-chats`, y faltaba justo donde más se nota: el bloque
 * "Firmada por" de la nota, que mostraba `Yohan Gonzalez · BCBA_ROLE` en un
 * texto de valor legal.
 */
export function roleLabel(role: string | null | undefined): string | null {
	return role ? role.replace('_ROLE', '') : null;
}
